<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option
      v-for="status in selects"
      :key="status.id"
      :value="status.id"
      :selected="status.id == selected"
      >{{ status.name }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectStatuses',
  data() {
    return {
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/invoice/statuses`).then((res) => (this.selects = res.data));
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
